// Block Version Configuration
// This file provides a simple interface to the version management system

// Import the version manager that coordinates between different version configs
import {
  getBlocksForVersion as getBlocksFromManager,
  getVersionedBlockName as getVersionedBlockNameFromManager,
  registerAssistingBlocks as registerAssistingBlocksFromManager,
} from "./blockVersions/versionManager";

export {
  getAvailableVersions,
  isVersionAtLeast,
  isVersionSupported,
} from "./blockVersions/versionManager";

export function getBlocksForVersion(snapVersion) {
    return getBlocksFromManager(snapVersion);
}

/**
 * Get the correct versioned block name for programmatic block creation
 * 
 * The function will automatically resolve to the correct version based on snapVersion:
 * - "rest_service" + "2026.0.0" → "rest_service"
 * - "rest_service" + "2026.1.0" → "rest_service_V2"
 * - "rest_service" + "2026.2.0" → "rest_service_V2" if 2026.2.0 still uses the rest_service_V2 block
 * 
 * @param {string} baseBlockName - The BASE block name WITHOUT version suffix (e.g., "rest_service", NOT "rest_service_V2")
 * @param {string} snapVersion - The Snap version (e.g., "2026.1.0")
 * @returns {string} The versioned block name to use (e.g., "rest_service_V2")
 */
export function getVersionedBlockName(baseBlockName, snapVersion) {
    return getVersionedBlockNameFromManager(baseBlockName, snapVersion);
}

/**
 * Register assisting blocks for backward compatibility
 * Calls the latest version which chains to all previous versions.
 * 
 * @param {Object} props - Props to pass to assisting blocks (typically { context })
 */
export function registerAssistingBlocks(props) {
    return registerAssistingBlocksFromManager(props);
}
